import omit from 'lodash/omit';
import pickBy from 'lodash/pickBy';
import { EntityType } from 'shared/constants/entityTypes';
import { getFieldConfig, postProcessPayload } from 'shared/utils/fields';
import { isNotEmpty, safeJsonParse } from 'shared/utils/functions';

const strategies = {
  merge: {},
  process: {
    [EntityType.ORDER]: (entity) => {
      return {
        _qbDataType: EntityType.ORDER,
        ...entity,
      };
    },

    [EntityType.SAMPLE]: (entity, parent, key) => {
      const fields = getFieldConfig(EntityType.SAMPLE);
      const isNested = !!key;

      return {
        _qbDataType: EntityType.SAMPLE,
        ...entity,
        ...(isNested ? postProcessPayload({ ...entity }, fields) : entity),
      };
    },

    [EntityType.TEST]: (entity) => {
      return omit(
        {
          _qbDataType: EntityType.TEST,
          ...entity,
          status: {
            value: entity.state || null,
            label: entity.state || '',
          },
        },
        ['state']
      );
    },

    [EntityType.ASSAY]: (entity) => {
      const testFields = getFieldConfig(EntityType.TEST);
      const { default_to_test_config: configJson, ...assay } = entity;
      const { tag_values: tags, ...defaultToTestValues } = pickBy(
        safeJsonParse(configJson),
        (v) => typeof v === 'boolean' || isNotEmpty(v)
      );
      const defaultToTestObj = { tags, ...defaultToTestValues };
      const _defaultToTestFields = testFields.map((field) => ({
        ...field,
        portal_default_value: defaultToTestObj[field.name] || field.portal_default_value,
      }));

      return {
        ...assay,
        _defaultToTestFields,
      };
    },
  },
  fallback: {},
};

export default strategies;
